/* joacă bună — quick-add pe cardurile de produs (doar produse cu o singură variantă):
   AJAX /cart/add.js, apoi 'jb:added' deschide cart drawer-ul existent (jb-cart-drawer.js). */
(function () {
  'use strict';

  function setState(btn, state) {
    btn.classList.remove('is-loading', 'is-added');
    if (state) btn.classList.add(state);
  }

  function onClick(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    setState(btn, 'is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add-failed'); return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        setState(btn, 'is-added');
        btn.dispatchEvent(new CustomEvent('jb:added', { bubbles: true, detail: { cart: cart } }));
        setTimeout(function () { setState(btn, null); btn.disabled = false; }, 1600);
      })
      .catch(function () {
        setState(btn, null);
        btn.disabled = false;
        var url = btn.getAttribute('data-product-url');
        if (url) window.location.href = url;
      });
  }

  document.addEventListener('click', onClick);
})();
